import apiService from './apiService';
import { getApiBaseUrl } from '../config/apiConfig';

const PREFIX = '/admin/clients';
const PRODUITS = '/admin/produits-marque';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res;
}

function authHeaders() {
  const token = localStorage.getItem('auth_token') || localStorage.getItem('jwt_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const clientAnnuaireService = {
  async list(params = {}) {
    const res = await request(apiService.get(PREFIX, params));
    const pagination = res.pagination || { page: 1, limit: 50, total: 0, pages: 0 };
    return {
      clients: Array.isArray(res.data?.clients) ? res.data.clients : [],
      pagination,
      identifiants_stats: res.data?.identifiants_stats || {
        total: pagination.total || 0,
        complets: 0,
        a_verifier: 0,
        partiels: 0,
      },
    };
  },

  async sync() {
    const res = await request(apiService.post(`${PREFIX}/sync`, {}, {}, { timeout: 300000 }));
    return res.data?.stats || {};
  },

  async update(id, body) {
    const res = await request(apiService.patch(`${PREFIX}/${id}`, body));
    return res.data?.client;
  },

  async reset(id) {
    const res = await request(apiService.post(`${PREFIX}/${id}/reset`));
    return res.data?.client;
  },

  async delete(id) {
    const res = await request(apiService.delete(`${PREFIX}/${id}`));
    return res.data?.client;
  },

  async restore(id) {
    const res = await request(apiService.post(`${PREFIX}/${id}/restore`));
    return res.data?.client;
  },

  async refreshLegal(id) {
    const res = await request(apiService.get(`${PREFIX}/${id}/legal`));
    return res.data?.client;
  },

  async applyPappers(id, body) {
    const res = await request(apiService.post(`${PREFIX}/${id}/pappers/apply`, body));
    return {
      client: res.data?.client,
      legal_destination: res.data?.legal_destination || 'dolibarr',
    };
  },

  async get(id) {
    const res = await request(apiService.get(`${PREFIX}/${id}`));
    return res.data?.client;
  },

  async updateIdentifiants(id, body) {
    const res = await request(apiService.patch(`${PREFIX}/${id}/identifiants`, body));
    return res.data?.client;
  },

  async identifiantsStats() {
    try {
      const res = await request(apiService.get(`${PREFIX}/identifiants-stats`));
      return res.data || { total: 0, complets: 0, a_verifier: 0, partiels: 0 };
    } catch {
      return { total: 0, complets: 0, a_verifier: 0, partiels: 0 };
    }
  },

  async exportCsv(params = {}) {
    const url = new URL(`${getApiBaseUrl()}${PREFIX}/export`);
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      const serialized = typeof value === 'string' ? value.trim() : String(value);
      if (serialized === '') return;
      url.searchParams.append(key, serialized);
    });
    const response = await fetch(url.toString(), {
      headers: { Accept: 'text/csv', ...authHeaders() },
    });
    if (!response.ok) {
      let message = 'Export CSV impossible';
      try {
        const body = await response.json();
        if (body?.message) message = body.message;
      } catch {
        // réponse non JSON
      }
      throw new Error(message);
    }
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = `annuaire-clients-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  },

  async listProduits() {
    const res = await request(apiService.get(PRODUITS));
    return Array.isArray(res.data?.produits) ? res.data.produits : [];
  },

  async listCommerciaux() {
    const res = await request(apiService.get('/secteurs/commerciaux'));
    return Array.isArray(res.data?.commerciaux) ? res.data.commerciaux : [];
  },

  async createProduit(body) {
    const res = await request(apiService.post(PRODUITS, body));
    return res.data?.produit;
  },

  async updateProduit(id, body) {
    const res = await request(apiService.patch(`${PRODUITS}/${id}`, body));
    return res.data?.produit;
  },

  async deleteProduit(id) {
    const res = await request(apiService.delete(`${PRODUITS}/${id}`));
    return res.data?.produit;
  },

  async restoreProduit(id) {
    const res = await request(apiService.post(`${PRODUITS}/${id}/restore`));
    return res.data?.produit;
  },

  async syncProduits() {
    const res = await request(apiService.post(`${PRODUITS}/sync`, {}, {}, { timeout: 300000 }));
    return {
      stats: res.data?.stats || {},
      produits: Array.isArray(res.data?.produits) ? res.data.produits : [],
    };
  },
};

export default clientAnnuaireService;
